import { render, staticRenderFns } from "./IndicadoresHistoricoRentabilidadNeta.vue?vue&type=template&id=da016480&"
import script from "./IndicadoresHistoricoRentabilidadNeta.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoRentabilidadNeta.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoRentabilidadNeta.vue?vue&type=style&index=0&id=da016480&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports